import React, { useState } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from "@mui/material";
import MessageIcon from "@mui/icons-material/Message";
import CardTable from "../../components/CardTable/CardTable";
import Button from "../../components/CustomButtons/Button.js";
import GenericModalText from "../../components/GenericModal/GenericModalText";
import { configTableAcumulated, modalsConfig } from "./config";
import { ColumnContainer, ListItemStyled, ListStyled, styles } from "./styles";

const useStyles = makeStyles(styles);

export const AcumSeries = () => {
  const classes = useStyles();
  const pipesAcum = useSelector((state) => state.pipesSeries.pipesAcum);
  const isLoadingPipes = useSelector(
    (state) => state.pipesSeries.isLoadingPipes
  );

  const [modals, setModals] = useState({
    item: null,
    message: false,
    text: "",
  });

  const handleCloseModals = (modal) => {
    setModals((prevState) => {
      return { ...prevState, [modal]: false };
    });
  };

  const handleOpenModals = (item, modal) => {
    setModals((prevState) => {
      return { ...prevState, item, [modal]: true };
    });
  };

  const columns = [
    ...configTableAcumulated,
    {
      Header: "Acciones",
      accessor: "id",
      sortable: false,
      filterable: false,
      Cell: (props) => (
        <ColumnContainer>
          <Tooltip
            id="tooltip-top"
            title="Ver/editar comentario"
            placement="top"
          >
            <Button
              justIcon
              round
              simple
              size="sm"
              onClick={() =>
                handleOpenModals(props.original, modalsConfig.message)
              }
              color="info"
              className="edit"
            >
              <MessageIcon />
            </Button>
          </Tooltip>
        </ColumnContainer>
      ),
    },
  ].map((col) => {
    return {
      ...col,
      headerClassName: `${classes.thTable}`,
    };
  });

  return (
    <React.Fragment>
      <CardTable
        data={pipesAcum}
        columns={columns}
        loading={isLoadingPipes}
        previousText="Anterior"
        nextText="Siguiente"
        noDataText="Sin datos"
        pageText="Pagina"
        ofText="de"
        resizable={false}
        rowsText="unidades"
      />
      <GenericModalText
        title="Comentarios"
        typeModal="message"
        subtitle={modals.item && modals.item.unit}
        isOpen={modals.message}
        onCloseModal={handleCloseModals}
      >
        <ListStyled>
          {modals.item
            ? modals.item.comments.map((comment, index) => (
                <ListItemStyled key={index}>{comment}</ListItemStyled>
              ))
            : null}
        </ListStyled>
      </GenericModalText>
    </React.Fragment>
  );
};
